const columns = [
    {
        type: 'selection',
        width: 100,
    },
    {
        title: '部门角色名称',
        key: 'bk_expl',
        width: 300,
    },
    {
        title: '所属部门',
        key: 'dept_cn_name',
        width: 200,
    },
    {
        title: '部门角色代码',
        key: 'dprl_code',
    },
    {
        title: '权重',
        width: 100,
        slot: 'InputNumber',
    },
];

export default columns;
